(function () {
  "use strict";

  const SELECTOR_ID = "naxarly-slot-selector";
  const STYLE_ID = "naxarly-slot-selector-style";
  const STATUS_CHECKING = "checking";
  const STATUS_UNKNOWN = "unknown";
  const TAMIL_NADU_DISTRICTS = [
    "Ariyalur", "Chengalpattu", "Chennai", "Coimbatore", "Cuddalore", "Dharmapuri",
    "Dindigul", "Erode", "Kallakurichi", "Kancheepuram", "Kanniyakumari", "Karur",
    "Krishnagiri", "Madurai", "Mayiladuthurai", "Nagapattinam", "Namakkal", "Nilgiris",
    "Perambalur", "Pudukkottai", "Ramanathapuram", "Ranipet", "Salem", "Sivaganga",
    "Tenkasi", "Thanjavur", "Theni", "Thoothukudi", "Tiruchirappalli", "Tirunelveli",
    "Tirupathur", "Tiruppur", "Tiruvallur", "Tiruvannamalai", "Tiruvarur", "Vellore",
    "Viluppuram", "Virudhunagar"
  ];
  const DISTRICT_COORDINATES = {
    "Ariyalur":[11.1401,79.0786],"Chengalpattu":[12.6819,79.9888],
    "Chennai":[13.0827,80.2707],"Coimbatore":[11.0168,76.9558],
    "Cuddalore":[11.7447,79.7680],"Dharmapuri":[12.1211,78.1582],
    "Dindigul":[10.3624,77.9695],"Erode":[11.3410,77.7172],
    "Kallakurichi":[11.7384,78.9622],"Kancheepuram":[12.8342,79.7036],
    "Kanniyakumari":[8.0883,77.5385],"Karur":[10.9601,78.0766],
    "Krishnagiri":[12.5186,78.2137],"Madurai":[9.9252,78.1198],
    "Mayiladuthurai":[11.1018,79.6526],"Nagapattinam":[10.7656,79.8424],
    "Namakkal":[11.2194,78.1677],"Nilgiris":[11.4064,76.6932],
    "Perambalur":[11.2320,78.8807],"Pudukkottai":[10.3833,78.8001],
    "Ramanathapuram":[9.3639,78.8395],"Ranipet":[12.9249,79.3333],
    "Salem":[11.6643,78.1460],"Sivaganga":[9.8433,78.4809],
    "Tenkasi":[8.9590,77.3152],"Thanjavur":[10.7870,79.1378],
    "Theni":[10.0104,77.4768],"Thoothukudi":[8.7642,78.1348],
    "Tiruchirappalli":[10.7905,78.7047],"Tirunelveli":[8.7139,77.7567],
    "Tirupathur":[12.4960,78.5730],"Tiruppur":[11.1085,77.3411],
    "Tiruvallur":[13.1439,79.9089],"Tiruvannamalai":[12.2253,79.0747],
    "Tiruvarur":[10.7661,79.6344],"Vellore":[12.9165,79.1325],
    "Viluppuram":[11.9401,79.4861],"Virudhunagar":[9.5680,77.9624]
  };

  let isMounted = false;
  let latestAvailability = null;
  let latestAvailabilityData = null;
  let listeners = [];
  let elements = {};
  let automaticRecheckTimer = null;
  let countdownTimer = null;

  function clone(value) {
    return JSON.parse(JSON.stringify(value));
  }

  function getEventApi() {
    return window.Naxarly && window.Naxarly.Event ? window.Naxarly.Event : null;
  }

  function getAvailabilityApi() {
    return window.Naxarly && window.Naxarly.Availability ? window.Naxarly.Availability : null;
  }

  function getDefaultAvailabilityData() {
    return window.Naxarly && window.Naxarly.availabilityData ? window.Naxarly.availabilityData : {};
  }

  function normalizeSlot(slot) {
    const source = slot || {};

    return {
      date: typeof source.date === "string" ? source.date : "",
      time: typeof source.time === "string" ? source.time : "",
      location: typeof source.location === "string" ? source.location : ""
    };
  }

  function getSavedSlot() {
    const eventApi = getEventApi();

    if (!eventApi) {
      return normalizeSlot();
    }

    const availability = eventApi.getAvailability();

    return normalizeSlot({
      date: availability.date,
      time: availability.time,
      location: availability.location || availability.city
    });
  }

  function setEventAvailability(slot, status) {
    const eventApi = getEventApi();

    if (!eventApi) {
      return;
    }

    const coordinates = DISTRICT_COORDINATES[slot.location];
    eventApi.setAvailability({
      date: slot.date,
      time: slot.time,
      city: slot.location,
      label: slot.location + ", Tamil Nadu",
      latitude: coordinates ? coordinates[0] : null,
      longitude: coordinates ? coordinates[1] : null,
      status: status || STATUS_UNKNOWN
    });
  }

  function injectStyles() {
    if (document.getElementById(STYLE_ID)) {
      return;
    }

    const style = document.createElement("style");
    style.id = STYLE_ID;
    style.textContent = [
      ".naxarly-slot-selector-lock { overflow: hidden; }",
      ".naxarly-slot-selector { position: fixed; inset: 0; z-index: 2147483000; display: none; }",
      ".naxarly-slot-selector.is-open { display: block; }",
      ".naxarly-slot-selector__overlay { position: absolute; inset: 0; border: 0; background: rgba(24, 16, 34, 0.42); }",
      ".naxarly-slot-selector__sheet { position: absolute; top: var(--naxarly-slot-top, 92px); left: 50%; width: min(92vw, 620px); max-height: calc(100vh - var(--naxarly-slot-top, 92px) - 18px); overflow: auto; background: #fff; color: #17131c; border: 1px solid #eadff5; border-radius: 20px; box-shadow: 0 24px 70px rgba(61, 25, 92, 0.28); transform: translate(-50%, -10px); opacity: 0; transition: transform 180ms ease, opacity 180ms ease; }",
      ".naxarly-slot-selector__sheet::before { content: ''; position: absolute; top: -8px; right: 18%; width: 16px; height: 16px; background: #fff; border-left: 1px solid #eadff5; border-top: 1px solid #eadff5; transform: rotate(45deg); }",
      ".naxarly-slot-selector.is-open .naxarly-slot-selector__sheet { transform: translate(-50%, 0); opacity: 1; }",
      ".naxarly-slot-selector__inner { width: 100%; margin: 0 auto; padding: 24px; box-sizing: border-box; }",
      ".naxarly-slot-selector__header { display: flex; align-items: center; justify-content: space-between; gap: 16px; margin-bottom: 18px; }",
      ".naxarly-slot-selector__title { margin: 0; font-size: 24px; line-height: 1.25; font-weight: 750; }",
      ".naxarly-slot-selector__close { width: 40px; height: 40px; border: 1px solid #d9d9d9; border-radius: 999px; background: #fff; color: #111; font-size: 24px; line-height: 1; cursor: pointer; }",
      ".naxarly-slot-selector__form { display: grid; gap: 18px; }",
      ".naxarly-slot-selector__field { display: grid; gap: 8px; padding-top: 2px; }",
      ".naxarly-slot-selector__field label { font-size: 15px; font-weight: 750; }",
      ".naxarly-slot-selector__field input, .naxarly-slot-selector__field select { width: 100%; min-height: 50px; box-sizing: border-box; border: 1.5px solid #6d28d9; border-radius: 12px; padding: 10px 14px; font: inherit; color: #17131c; background: #fff; outline: none; }",
      ".naxarly-slot-selector__field input:focus, .naxarly-slot-selector__field select:focus { box-shadow: 0 0 0 3px #f3e8ff; }",
      ".naxarly-slot-selector__hint { margin: 0; color: #6f6676; font-size: 12px; }",
      ".naxarly-slot-selector__error { min-height: 20px; color: #a40000; font-size: 14px; line-height: 1.4; }",
      ".naxarly-slot-selector__temporary { display: grid; gap: 6px; padding: 12px; border: 1px solid #e5ddfb; border-radius: 10px; background: #f4f0ff; color: #3f20b2; }",
      ".naxarly-slot-selector__temporary strong { color: #1c1b2d; }",
      ".naxarly-slot-selector__recheck { width: max-content; min-height: 32px; padding: 6px 10px; border: 1px solid #5f2498; border-radius: 8px; background: #fff; color: #5f2498; font: inherit; font-size: 13px; font-weight: 700; cursor: pointer; }",
      ".naxarly-slot-selector__alternatives { display: flex; flex-wrap: wrap; gap: 6px; margin-top: 4px; }",
      ".naxarly-slot-selector__alternative { min-height: 30px; padding: 5px 9px; border: 1px solid #e5ddfb; border-radius: 8px; background: #fff; color: #3f20b2; font: inherit; font-size: 12px; cursor: pointer; }",
      ".naxarly-slot-selector__actions { display: flex; margin-top: 2px; }",
      ".naxarly-slot-selector__button { min-height: 46px; border: 1px solid #111; border-radius: 8px; padding: 0 18px; font: inherit; font-weight: 700; cursor: pointer; }",
      ".naxarly-slot-selector__button--secondary { background: #fff; color: #111; }",
      ".naxarly-slot-selector__button--primary { width: 100%; border-color: #6d28d9; background: linear-gradient(135deg, #7e22ce, #581c87); color: #fff; }",
      ".naxarly-slot-selector__button[disabled] { opacity: 0.64; cursor: wait; }",
      "@media (max-width: 749px) { .naxarly-slot-selector__sheet { width: calc(100vw - 24px); } .naxarly-slot-selector__inner { padding: 20px; } .naxarly-slot-selector__title { font-size: 21px; } }"
    ].join("");

    document.head.appendChild(style);
  }

  function createField(id, labelText, type, autocomplete) {
    const field = document.createElement("div");
    const label = document.createElement("label");
    const input = document.createElement("input");

    field.className = "naxarly-slot-selector__field";
    label.setAttribute("for", id);
    label.textContent = labelText;
    input.id = id;
    input.name = id;
    input.type = type;
    input.autocomplete = autocomplete;

    field.appendChild(label);
    field.appendChild(input);

    return {
      field: field,
      input: input
    };
  }

  function createLocationField() {
    const result = createField("naxarly-slot-location", "Event location", "search", "address-level2");
    const list = document.createElement("datalist");
    const hint = document.createElement("p");

    list.id = "naxarly-tamil-nadu-districts";
    TAMIL_NADU_DISTRICTS.forEach(function (district) {
      const option = document.createElement("option");
      option.value = district;
      list.appendChild(option);
    });
    result.input.setAttribute("list", list.id);
    result.input.placeholder = "Search Tamil Nadu districts";
    hint.className = "naxarly-slot-selector__hint";
    hint.textContent = "Search and select any district";
    result.field.appendChild(list);
    result.field.appendChild(hint);
    return result;
  }

  function createTimeField() {
    const field = document.createElement("div");
    const label = document.createElement("label");
    const select = document.createElement("select");

    field.className = "naxarly-slot-selector__field";
    label.setAttribute("for", "naxarly-slot-time");
    label.textContent = "Event start time";
    select.id = "naxarly-slot-time";
    select.name = "naxarly-slot-time";
    for (let minutes = 0; minutes < 24 * 60; minutes += 30) {
      const hour = Math.floor(minutes / 60);
      const minute = minutes % 60;
      const option = document.createElement("option");
      const hour12 = hour % 12 || 12;
      const suffix = hour < 12 ? "AM" : "PM";
      option.value = String(hour).padStart(2, "0") + ":" + String(minute).padStart(2, "0");
      option.textContent = hour12 + ":" + String(minute).padStart(2, "0") + " " + suffix;
      select.appendChild(option);
    }
    field.appendChild(label);
    field.appendChild(select);
    return { field: field, input: select };
  }

  function mount() {
    if (isMounted) {
      return;
    }

    injectStyles();

    const root = document.createElement("div");
    const overlay = document.createElement("button");
    const sheet = document.createElement("div");
    const inner = document.createElement("div");
    const header = document.createElement("div");
    const title = document.createElement("h2");
    const closeButton = document.createElement("button");
    const form = document.createElement("form");
    const locationField = createLocationField();
    const dateField = createField("naxarly-slot-date", "Event date", "date", "off");
    dateField.input.min = new Date().toLocaleDateString("en-CA", {
      timeZone: "Asia/Kolkata"
    });
    const timeField = createTimeField();
    const error = document.createElement("div");
    const actions = document.createElement("div");
    const submitButton = document.createElement("button");

    root.id = SELECTOR_ID;
    root.className = "naxarly-slot-selector";
    root.setAttribute("aria-hidden", "true");

    overlay.className = "naxarly-slot-selector__overlay";
    overlay.type = "button";
    overlay.setAttribute("aria-label", "Close event slot selector");

    sheet.className = "naxarly-slot-selector__sheet";
    sheet.setAttribute("role", "dialog");
    sheet.setAttribute("aria-modal", "true");
    sheet.setAttribute("aria-labelledby", "naxarly-slot-selector-title");

    inner.className = "naxarly-slot-selector__inner";
    header.className = "naxarly-slot-selector__header";
    title.id = "naxarly-slot-selector-title";
    title.className = "naxarly-slot-selector__title";
    title.textContent = "Plan your event";

    closeButton.className = "naxarly-slot-selector__close";
    closeButton.type = "button";
    closeButton.setAttribute("aria-label", "Close event slot selector");
    closeButton.textContent = "\u00d7";

    form.className = "naxarly-slot-selector__form";
    error.className = "naxarly-slot-selector__error";
    error.setAttribute("role", "alert");

    actions.className = "naxarly-slot-selector__actions";
    submitButton.className = "naxarly-slot-selector__button naxarly-slot-selector__button--primary";
    submitButton.type = "submit";
    submitButton.textContent = "Apply event details";

    header.appendChild(title);
    header.appendChild(closeButton);
    actions.appendChild(submitButton);
    form.appendChild(locationField.field);
    form.appendChild(dateField.field);
    form.appendChild(timeField.field);
    form.appendChild(error);
    form.appendChild(actions);
    inner.appendChild(header);
    inner.appendChild(form);
    sheet.appendChild(inner);
    root.appendChild(overlay);
    root.appendChild(sheet);
    document.body.appendChild(root);

    elements = {
      root: root,
      form: form,
      dateInput: dateField.input,
      timeInput: timeField.input,
      locationInput: locationField.input,
      error: error,
      closeButton: closeButton,
      submitButton: submitButton
    };

    overlay.addEventListener("click", close);
    closeButton.addEventListener("click", close);
    form.addEventListener("submit", handleSubmit);
    document.addEventListener("keydown", handleKeydown);

    isMounted = true;
  }

  function handleKeydown(event) {
    if (event.key === "Escape" && elements.root && elements.root.classList.contains("is-open")) {
      close();
    }
  }

  function setFormSlot(slot) {
    const normalizedSlot = normalizeSlot(slot);

    elements.dateInput.value = normalizedSlot.date;
    elements.timeInput.value = normalizedSlot.time;
    elements.locationInput.value = normalizedSlot.location;
  }

  function readFormSlot() {
    return normalizeSlot({
      date: elements.dateInput.value,
      time: elements.timeInput.value,
      location: elements.locationInput.value
    });
  }

  function validateSlot(slot) {
    if (!slot.date || !slot.time || !slot.location) {
      return "Please choose a date, time, and location.";
    }
    if (!DISTRICT_COORDINATES[slot.location]) {
      return "Please select a Tamil Nadu district from the list.";
    }

    const selectedStart = new Date(slot.date + "T" + slot.time + ":00+05:30");
    if (Number.isNaN(selectedStart.getTime()) || selectedStart.getTime() <= Date.now()) {
      return "Please select an event start time in the future.";
    }

    return "";
  }

  function setLoading(isLoading) {
    elements.submitButton.disabled = isLoading;
    elements.submitButton.textContent = isLoading ? "Checking..." : "Apply event details";
  }

  function clearTemporaryTimers() {
    if (automaticRecheckTimer) window.clearTimeout(automaticRecheckTimer);
    if (countdownTimer) window.clearInterval(countdownTimer);
    automaticRecheckTimer = null;
    countdownTimer = null;
  }

  function showTemporaryReservation(slot, availability) {
    clearTemporaryTimers();
    elements.error.replaceChildren();
    const box = document.createElement("div");
    const title = document.createElement("strong");
    const message = document.createElement("span");
    const countdown = document.createElement("span");
    const button = document.createElement("button");
    box.className = "naxarly-slot-selector__temporary";
    title.textContent = "Temporarily reserved";
    message.textContent = availability.message || "Another customer is completing checkout.";
    button.type = "button";
    button.className = "naxarly-slot-selector__recheck";
    button.textContent = "Check again";
    button.addEventListener("click", function () { elements.form.requestSubmit(); });
    const retryAt = availability.retryAt ? new Date(availability.retryAt) : new Date(Date.now() + 10 * 60_000);
    function drawCountdown() {
      const remaining = Math.max(0, retryAt.getTime() - Date.now());
      const minutes = Math.floor(remaining / 60_000);
      const seconds = Math.floor((remaining % 60_000) / 1000);
      countdown.textContent = "We’ll check again automatically · " + String(minutes).padStart(2, "0") + ":" + String(seconds).padStart(2, "0");
    }
    drawCountdown();
    countdownTimer = window.setInterval(drawCountdown, 1000);
    automaticRecheckTimer = window.setTimeout(function () { elements.form.requestSubmit(); }, 25_000);
    box.append(title, message, countdown, button);
    appendAlternatives(box, availability);
    elements.error.appendChild(box);
  }

  function appendAlternatives(container, availability) {
    const alternatives = (availability.alternativeSlots || []).filter(function (item) { return item.available; });
    if (!alternatives.length) return;
    const holder = document.createElement("div");
    holder.className = "naxarly-slot-selector__alternatives";
    alternatives.forEach(function (item) {
      const date = new Date(item.startsAt);
      const parts = new Intl.DateTimeFormat("en-IN", { timeZone: "Asia/Kolkata", hour: "2-digit", minute: "2-digit", hourCycle: "h23" }).formatToParts(date);
      const hour = parts.find(function (part) { return part.type === "hour"; })?.value || "00";
      const minute = parts.find(function (part) { return part.type === "minute"; })?.value || "00";
      const choice = document.createElement("button");
      choice.type = "button";
      choice.className = "naxarly-slot-selector__alternative";
      choice.textContent = date.toLocaleTimeString("en-IN", { timeZone: "Asia/Kolkata", hour: "numeric", minute: "2-digit" }) + " · Available";
      choice.addEventListener("click", function () { elements.timeInput.value = hour + ":" + minute; elements.form.requestSubmit(); });
      holder.appendChild(choice);
    });
    container.appendChild(holder);
  }

  function notifyListeners(availability) {
    const payload = clone(availability);

    listeners.forEach(function (callback) {
      callback(payload);
    });
  }

  async function handleSubmit(event) {
    event.preventDefault();

    const availabilityApi = getAvailabilityApi();
    const slot = readFormSlot();
    const error = validateSlot(slot);

    clearTemporaryTimers();
    elements.error.textContent = error;

    if (error) {
      return;
    }

    if (!availabilityApi || typeof availabilityApi.check !== "function") {
      elements.error.textContent = "Availability is not ready yet.";
      return;
    }

    setLoading(true);
    setEventAvailability(slot, STATUS_CHECKING);

    try {
      latestAvailability = await Promise.resolve(
        availabilityApi.check(
          slot,
          latestAvailabilityData || getDefaultAvailabilityData()
        )
      );
      setEventAvailability(slot, latestAvailability.status);
      notifyListeners(latestAvailability);
      if (latestAvailability.status === "temporarily_reserved") {
        showTemporaryReservation(slot, latestAvailability);
        return;
      }
      if (latestAvailability.status !== "available") {
        elements.error.textContent =
          latestAvailability.message ||
          "This package is unavailable for the selected event slot.";
        appendAlternatives(elements.error, latestAvailability);
        return;
      }
      close();
    } catch (error) {
      elements.error.textContent = "Availability could not be checked.";
      setEventAvailability(slot, STATUS_UNKNOWN);
    } finally {
      setLoading(false);
    }
  }

  function close() {
    if (!isMounted) {
      return;
    }

    clearTemporaryTimers();
    elements.root.classList.remove("is-open");
    elements.root.setAttribute("aria-hidden", "true");
    document.documentElement.classList.remove("naxarly-slot-selector-lock");
  }

  window.Naxarly = window.Naxarly || {};

  window.Naxarly.SlotSelector = {
    /**
     * Open the reusable event slot selector bottom sheet.
     * @param {Object} [options] Optional configuration.
     * @param {Object} [options.availabilityData] Availability data to pass into the availability engine.
     * @returns {Object} The current public API.
     */
    open: function (options) {
      const settings = options || {};

      mount();

      latestAvailabilityData = settings.availabilityData || latestAvailabilityData || getDefaultAvailabilityData();
      elements.error.textContent = "";
      setLoading(false);
      setFormSlot(settings.slot || getSavedSlot());
      elements.root.classList.add("is-open");
      elements.root.setAttribute("aria-hidden", "false");
      document.documentElement.classList.add("naxarly-slot-selector-lock");
      const trigger = document.querySelector("[data-naxarly-slot-trigger]");
      if (trigger) {
        const bounds = trigger.getBoundingClientRect();
        elements.root.style.setProperty("--naxarly-slot-top", Math.max(76, bounds.bottom + 12) + "px");
      }
      elements.locationInput.focus();

      return window.Naxarly.SlotSelector;
    },

    /**
     * Close the event slot selector bottom sheet.
     * @returns {Object} The current public API.
     */
    close: function () {
      close();

      return window.Naxarly.SlotSelector;
    },

    /**
     * Get the currently selected event slot.
     * @returns {Object} A deep clone of the selected slot.
     */
    getSlot: function () {
      if (isMounted && elements.root.classList.contains("is-open")) {
        return clone(readFormSlot());
      }

      return clone(getSavedSlot());
    },

    /**
     * Get the latest availability result.
     * @returns {Object|null} A deep clone of the latest availability result, or null before a check.
     */
    getAvailability: function () {
      return latestAvailability ? clone(latestAvailability) : null;
    },

    /**
     * Subscribe to availability changes.
     * @param {Function} callback Function called with the latest availability result.
     * @returns {Function} Unsubscribe function.
     */
    subscribe: function (callback) {
      if (typeof callback !== "function") {
        return function () {};
      }

      listeners.push(callback);

      return function () {
        listeners = listeners.filter(function (listener) {
          return listener !== callback;
        });
      };
    }
  };
})();
